export type ProductTypeKey = 'appliances' | 'sinkAndTap';
type ProductTypeLabel = 'Electroménagers' | 'Eviers et mitigeurs';

/**
 * Maps a product category key to its display label.
 *
 * @param type - Must be one of 'appliances' or 'sinkAndTap'.
 * @returns The corresponding display label in French.
 */
export function getProductTypeLabel(type: ProductTypeKey): ProductTypeLabel {
  const map: Record<ProductTypeKey, ProductTypeLabel> = {
    appliances: 'Electroménagers',
    sinkAndTap: 'Eviers et mitigeurs',
  };

  return map[type];
}
